import { render, staticRenderFns } from "./DeliveryCampaignGroupLogsPage.vue?vue&type=template&id=3355d1a4&scoped=true"
import script from "./DeliveryCampaignGroupLogsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupLogsPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCampaignGroupLogsPage.vue?vue&type=style&index=0&id=3355d1a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355d1a4",
  null
  
)

export default component.exports